export default __webpack_public_path__ + "static/media/sheren-heskel-z.00ee2150.png";